import { API_URL } from '@/lib/utils';


export const API_UNREACHABLE_EVENT = 'api:unreachable';
export const API_REACHABLE_EVENT = 'api:reachable';
const PROBE_TIMEOUT_MS = 8000;

export function isNetworkError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === 'AbortError') return false;
  return error instanceof TypeError;
}

function reportUnreachable(): void {
  window.dispatchEvent(new Event(API_UNREACHABLE_EVENT));
}

function reportReachable(): void {
  window.dispatchEvent(new Event(API_REACHABLE_EVENT));
}

export async function trackedFetch(url: string, init: RequestInit = {}): Promise<Response> {
  try {
    const response = await fetch(url, init);
    reportReachable();
    return response;
  } catch (err) {
    if (isNetworkError(err)) reportUnreachable();
    throw err;
  }
}

export async function pingServer(): Promise<boolean> {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), PROBE_TIMEOUT_MS);

  try {
    await fetch(`${API_URL}/`, { method: 'GET', cache: 'no-store', signal: controller.signal });
    return true;
  } catch {
    return false;
  } finally {
    window.clearTimeout(timer);
  }
}
